var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_ring"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 86",
    d: "M13.3672 23.25C12.0868 23.25 10.8189 22.9978 9.63602 22.5078C8.4531 22.0178 7.37827 21.2997 6.4729 20.3943C5.56752 19.4889 4.84934 18.4141 4.35936 17.2312C3.86938 16.0482 3.61719 14.7804 3.61719 13.5C3.61719 12.2196 3.86938 10.9518 4.35936 9.76884C4.84935 8.58591 5.56753 7.51108 6.4729 6.60571C7.37827 5.70034 8.4531 4.98216 9.63603 4.49217C10.819 4.00219 12.0868 3.75 13.3672 3.75C14.6476 3.75 15.9154 4.00219 17.0984 4.49218C18.2813 4.98216 19.3561 5.70034 20.2615 6.60571C21.1669 7.51108 21.885 8.58591 22.375 9.76884C22.865 10.9518 23.1172 12.2196 23.1172 13.5C23.1172 14.7804 22.865 16.0482 22.375 17.2312C21.885 18.4141 21.1668 19.4889 20.2615 20.3943C19.3561 21.2997 18.2813 22.0178 17.0983 22.5078C15.9154 22.9978 14.6476 23.25 13.3672 23.25L13.3672 23.25Z",
    stroke: "url(#paint0_linear_862_9564)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 112",
    d: "M10.1172 10.25L16.6172 16.75",
    stroke: "url(#paint1_linear_862_9564)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 113",
    d: "M16.6172 10.25L10.1172 16.75",
    stroke: "url(#paint2_linear_862_9564)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_9564",
    x1: 13.3672,
    y1: 3.75,
    x2: 13.3672,
    y2: 23.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_9564",
    x1: 13.3672,
    y1: 10.25,
    x2: 13.3672,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_862_9564",
    x1: 13.3672,
    y1: 10.25,
    x2: 13.3672,
    y2: 16.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6c5397123e9790cbdd4afbf47ffa0b77.svg";
export { ForwardRef as ReactComponent };